import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import EnumService from "services/EnumService";
export const initialState = {
  dataDiscount: [],
  dataTrx: [],
  dataTicket: [],
  dataImport: [],
  dataProduct: [],
  dataReport: [],
  dataMenuBo: null,
  dataMenuFo: null,
  loading: false,
  error: null,
};

export const fetchDiscountData = createAsyncThunk(
  "enumm/fetchDiscountData",
  async (_, { rejectWithValue }) => {
    try {
      const response = await EnumService.getDiscountType();
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error");
    }
  }
);

export const fetchTrxData = createAsyncThunk(
  "enumm/fetchTrxData",
  async (_, { rejectWithValue }) => {
    try {
      const response = await EnumService.getTrxType();
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error");
    }
  }
);

export const fetchTicketData = createAsyncThunk(
  "enumm/fetchTicketData",
  async (_, { rejectWithValue }) => {
    try {
      const response = await EnumService.getTicketType();
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error");
    }
  }
);

export const fetchImportData = createAsyncThunk(
  "enumm/fetchImportData",
  async (_, { rejectWithValue }) => {
    try {
      const response = await EnumService.getImportType();
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error");
    }
  }
);

export const fetchProductTypeData = createAsyncThunk(
  "enumm/fetchProductTypeData",
  async (_, { rejectWithValue }) => {
    try {
      const response = await EnumService.getProductType();
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error");
    }
  }
);

export const fetchReportTypeData = createAsyncThunk(
  "enumm/fetchReportTypeData",
  async (_, { rejectWithValue }) => {
    try {
      const response = await EnumService.getReportType();
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error");
    }
  }
);

export const enummSlice = createSlice({
  name: "enumm",
  initialState,
  reducers: {
    getMenuBo: (state) => {
      state.dataMenuBo = localStorage.getItem("boMenus")?.split(",");
    },
    getMenuFo: (state) => {
      state.dataMenuFo = localStorage.getItem("foMenus")?.split(",");
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDiscountData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDiscountData.fulfilled, (state, action) => {
        state.loading = false;
        state.dataDiscount = action.payload.data;
      })
      .addCase(fetchDiscountData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchTrxData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchTrxData.fulfilled, (state, action) => {
        state.loading = false;
        state.dataTrx = action.payload.data;
      })
      .addCase(fetchTrxData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchTicketData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchTicketData.fulfilled, (state, action) => {
        state.loading = false;
        state.dataTicket = action.payload.data;
      })
      .addCase(fetchTicketData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchImportData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchImportData.fulfilled, (state, action) => {
        state.loading = false;
        state.dataImport = action.payload.data;
      })
      .addCase(fetchImportData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchProductTypeData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchProductTypeData.fulfilled, (state, action) => {
        state.loading = false;
        state.dataProduct = action.payload.data;
      })
      .addCase(fetchProductTypeData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchReportTypeData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchReportTypeData.fulfilled, (state, action) => {
        state.loading = false;
        state.dataReport = action.payload.data;
      })
      .addCase(fetchReportTypeData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { getMenuBo, getMenuFo } = enummSlice.actions;

export default enummSlice.reducer;
